import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { AuthService } from '@auth0/auth0-angular';
import { AuthService as AuthS } from './_services/auth.service';
import { Router, RouterOutlet } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TosModalComponent } from './layout/_modals/tos-modal/tos-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    LucideAngularModule,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  public title: string = 'HRCI CHAT';

  constructor(
    private auth0Service: AuthService,
    private authService: AuthS,
    private router: Router,
    private modal: NgbModal
  ) {

    this.auth0Service.user$.subscribe((data) => {
      if (data) {
         if (!this.authService.tosApplied) {
          this.modal.open(TosModalComponent, { size: 'xl', backdrop: 'static', keyboard: false }).result.then((data) => {
            if (data === 'tos_accepted') {
              this.authService.tosApplied = true;
            }
          });
        }
        this.auth0Service.idTokenClaims$.subscribe((data) => {
          this.authService.expirationDate = data?.exp ? new Date(data.exp * 1000) : 0.3;
          this.authService.userToken = data?.__raw || null;
        });
      }
    });

    this.auth0Service.error$.subscribe((data: Error) => {
      if (data) {        
        this.authService.errorMessage = data.message;
        this.authService.errorCode = data.name;
        this.router.navigate(['login-error']);
      }
    });
  }
}
